import React from 'react';

function DividendHistory() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-white mb-8">Dividend History</h1>
        
        <div className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-xl border border-purple-500/30">
          <p className="text-gray-400 text-center py-8">
            No dividend history available yet. Start distributing dividends to see them here!
          </p>
        </div>
      </div>
    </div>
  );
}

export default DividendHistory;